import type { BundleRecommendationResponse } from "../types/viewmodel";

interface BundleRecommendationRequest {
	pageType: string;
	itemPageDataModel: { id: string };
	recsPlacementIds: string[];
	promoPlacementIds: string[];
}

export async function getRecommendations(
	bundleId: string,
): Promise<BundleRecommendationResponse> {
	const request: BundleRecommendationRequest = {
		pageType: "Item",
		itemPageDataModel: { id: bundleId },
		recsPlacementIds: ["kpc_accessories"],
		promoPlacementIds: [],
	};

	const response = await fetch("/rr/GetPlacementsAndPromos", {
		method: "POST",
		headers: {
			"Content-Type": "application/json",
		},
		body: JSON.stringify(request),
	});

	if (!response.ok) {
		throw new Error(`Failed to fetch recommendations: ${response.statusText}`);
	}

	return response.json();
}
